<template>
  <div id="app">
    <PageHeader />
    <router-view />
    <MinorCountdown />
    <GlobalToast />
    <GlobalConfirmDialog />
  </div>
</template>

<script>
import PageHeader from './components/Header.vue'
import MinorCountdown from './components/MinorCountdown.vue'
import GlobalToast from './components/Toast.vue'
import GlobalConfirmDialog from './components/ConfirmDialog.vue'

export default {
  name: 'App',
  components: {
    PageHeader,
    MinorCountdown,
    GlobalToast,
    GlobalConfirmDialog
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f6f7f9;
}
#app > router-view,
#app > .page-wrap {
  flex: 1;
}

body {
  margin: 0;
  padding: 0;
}
</style>
